// extracted by mini-css-extract-plugin
export default {"flexp":"addaddress_flexp__AZtLk","flex":"addaddress_flex__ZA3V7","box":"addaddress_box__AHJ6h"};